// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flyout-card {
    height: auto;
    border-radius: 0;
    overflow-y: auto;
    box-shadow: none;
}

.flyout-media-section {
    display: flex;
    margin-left: 3%;
    position: relative;
}

.flyout-media-wrapper {
    flex: 1;
    position: relative;
}

.flyout-media {
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 536px;
    height: 301.5px;
    margin-top: 6%;
    margin-left: 10%;
    background-position: center;
    background-size: auto;
}

.flyout-media-success {
    background-color: #4caf50;
}

.flyout-media-secondary {
    background-color: #9e9e9e;
}

.flyout-media-info {
    background-color: #2196f3;
}

.flyout-media-warning {
    background-color: #ff9800;
}

.flyout-media-primary {
    background-color: #9c27b0;
}

.flyout-play-icon {
    position: absolute;
    font-size: 4rem;
    bottom: 45%;
    right: 45%;
    background-color: white;
    border-radius: 56%;
    cursor: pointer;
}

.flyout-actions-column {
    margin-top: 4%;
    margin-left: 3.2%;
}

.flyout-action-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-left: 8%;
}

.flyout-action-button {
    background: white;
    padding: 0;
}

.flyout-action-button:hover {
    background: white;
}

.flyout-action-icon {
    padding: 15%;
    font-size: 2rem !important;
    border-radius: 50%;
}

.flyout-action-icon:hover {
    background: #efeaea;
}

.flyout-action-icon-colored {
    color: #2E3F80;
    padding: 25%;
}

.flyout-copy-success {
    font-size: 12px;
    color: #4caf50;
    text-align: center;
}

.flyout-header {
    display: flex;
    padding-left: 8px !important;
    align-items: center;
}

.flyout-category {
    font-size: small;
    margin-top: 10px;
    color: #767786;
    font-weight: 600;
    text-transform: uppercase;
}

.flyout-status {
    margin-left: auto;
    margin-right: 0;
}

.flyout-title {
    margin-left: 6px;
    font-family: sans-serif;
    font-weight: 600 !important;
    font-size: 24px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.flyout-copy-fallback {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
}

.flyout-copy-label {
    white-space: nowrap;
}

.flyout-description {
    font-size: 16px;
    font-family: sans-serif;
}

.flyout-description-list {
    margin-left: 2px;
}

.flyout-footer {
    margin-bottom: 12px;
    margin-left: 15px;
    display: flex;
    align-items: center;
}

.flyout-footer-item {
    display: flex;
    align-items: center;
    margin-right: 13px;
}

.flyout-footer-follow {
    justify-content: center;
}

.flyout-footer-link {
    padding-top: 0;
    float: left;
    margin-right: 10px;
    cursor: pointer;
}

.flyout-link-icon {
    width: 2rem;
    height: 100%;
}

.flyout-link-icon-small {
    height: 100%;
    margin-right: 3px;
}

.flyout-link-text {
    text-transform: none;
    color: #2E3F80;
    font-weight: 600;
    cursor: pointer;
    font-family: sans-serif;
    font-size: 14px;
}

.flyout-product-container {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
}

.flyout-product-chip {
    margin-left: 8px;
    font-size: small;
    background-color: #f9f3f3;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/Flyout.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".flyout-card {\n    height: auto;\n    border-radius: 0;\n    overflow-y: auto;\n    box-shadow: none;\n}\n\n.flyout-media-section {\n    display: flex;\n    margin-left: 3%;\n    position: relative;\n}\n\n.flyout-media-wrapper {\n    flex: 1;\n    position: relative;\n}\n\n.flyout-media {\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 536px;\n    height: 301.5px;\n    margin-top: 6%;\n    margin-left: 10%;\n    background-position: center;\n    background-size: auto;\n}\n\n.flyout-media-success {\n    background-color: #4caf50;\n}\n\n.flyout-media-secondary {\n    background-color: #9e9e9e;\n}\n\n.flyout-media-info {\n    background-color: #2196f3;\n}\n\n.flyout-media-warning {\n    background-color: #ff9800;\n}\n\n.flyout-media-primary {\n    background-color: #9c27b0;\n}\n\n.flyout-play-icon {\n    position: absolute;\n    font-size: 4rem;\n    bottom: 45%;\n    right: 45%;\n    background-color: white;\n    border-radius: 56%;\n    cursor: pointer;\n}\n\n.flyout-actions-column {\n    margin-top: 4%;\n    margin-left: 3.2%;\n}\n\n.flyout-action-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-left: 8%;\n}\n\n.flyout-action-button {\n    background: white;\n    padding: 0;\n}\n\n.flyout-action-button:hover {\n    background: white;\n}\n\n.flyout-action-icon {\n    padding: 15%;\n    font-size: 2rem !important;\n    border-radius: 50%;\n}\n\n.flyout-action-icon:hover {\n    background: #efeaea;\n}\n\n.flyout-action-icon-colored {\n    color: #2E3F80;\n    padding: 25%;\n}\n\n.flyout-copy-success {\n    font-size: 12px;\n    color: #4caf50;\n    text-align: center;\n}\n\n.flyout-header {\n    display: flex;\n    padding-left: 8px !important;\n    align-items: center;\n}\n\n.flyout-category {\n    font-size: small;\n    margin-top: 10px;\n    color: #767786;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.flyout-status {\n    margin-left: auto;\n    margin-right: 0;\n}\n\n.flyout-title {\n    margin-left: 6px;\n    font-family: sans-serif;\n    font-weight: 600 !important;\n    font-size: 24px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.flyout-copy-fallback {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-top: 16px;\n    margin-bottom: 16px;\n}\n\n.flyout-copy-label {\n    white-space: nowrap;\n}\n\n.flyout-description {\n    font-size: 16px;\n    font-family: sans-serif;\n}\n\n.flyout-description-list {\n    margin-left: 2px;\n}\n\n.flyout-footer {\n    margin-bottom: 12px;\n    margin-left: 15px;\n    display: flex;\n    align-items: center;\n}\n\n.flyout-footer-item {\n    display: flex;\n    align-items: center;\n    margin-right: 13px;\n}\n\n.flyout-footer-follow {\n    justify-content: center;\n}\n\n.flyout-footer-link {\n    padding-top: 0;\n    float: left;\n    margin-right: 10px;\n    cursor: pointer;\n}\n\n.flyout-link-icon {\n    width: 2rem;\n    height: 100%;\n}\n\n.flyout-link-icon-small {\n    height: 100%;\n    margin-right: 3px;\n}\n\n.flyout-link-text {\n    text-transform: none;\n    color: #2E3F80;\n    font-weight: 600;\n    cursor: pointer;\n    font-family: sans-serif;\n    font-size: 14px;\n}\n\n.flyout-product-container {\n    display: flex;\n    justify-content: flex-end;\n    padding: 0 30px;\n}\n\n.flyout-product-chip {\n    margin-left: 8px;\n    font-size: small;\n    background-color: #f9f3f3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
